import { patch } from 'core_main/request';

import { UpdateConversationParameters } from './types';
import {
  validateUpdateConversationParams,
  makeConversationEndpoint,
} from './helpers';

export const updateConversation = (
  parameters: UpdateConversationParameters,
) => {
  const validationError = validateUpdateConversationParams(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  const { conversationId, custom } = parameters;

  return patch(makeConversationEndpoint(conversationId), {
    body: JSON.stringify({ custom }),
  });
};
